'use strict';

module.exports = require('./_eq')(require('es5-ext/object/eq'));
